import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChordCalc } from '../chord/ChordCalc';

@Component({
  selector: 'app-view-chord',
  templateUrl: './Chord.html',
  styleUrls: ['./style.css']
})
export class AppViewChord {
  public note: string | null = null;
  public guitar: ChordCalc;
  public ukulele: ChordCalc;
  constructor(private readonly route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.note = ('' + (params['note'] ? params['note'] : this.note)).replace('_sharp_', '#');
    });
    this.guitar = ChordCalc.init.guitar("" + this.note);
    this.ukulele = ChordCalc.init.ukulele("" + this.note);
  }
}
